import styled from 'styled-components';

import Divider from '../Divider';
import Drawer from '../Drawer';
import { List, ListItem } from '../List';
import ProfileInfo from '../ProfileInfo';

export const ContainerAvatar = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  user-select: none;
  padding-top: 64px;
  .username {
    width: 196px;
    height: 42px;
    margin: 16px 42px 33px;
    font-size: 16px;
    font-weight: 600;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.31;
    letter-spacing: normal;
    text-align: center;
    color: #3a3a3a;
    text-transform: capitalize;
  }
  @media (min-width: 740px) {
    display: none;
  }
`;

export const MenuDrawer = styled(Drawer)`
  width: 280px;
  height: 100%;
  margin: 0 79px 0 0;
  box-shadow: 10px 0 31px 0 rgba(231, 238, 255, 0.5);
  background-color: white;
  @media (min-width: 480px) {
    margin: 0;
    max-width: 280px;
    min-height: 100vh;
  }
`;

export const ButtonIcon = styled.button`
  border: none;
  background: transparent;
  width: 24px;
  height: 24px;
  display: flex;
  align-content: center;
  justify-content: center;
`;

export const CloseIcon = styled(ButtonIcon)`
  left: 16px;
  position: absolute;
  top: 16px;
  z-index: 9999;
  font-size: 24px;
  color: #737373;
  padding: 0;
  @media (min-width: 740px) {
    display: none;
  }
`;

export const MenuList = styled(List)`
  margin-top: 8px;
`;

export const StyledMenuItem = styled(ListItem)<{ active?: boolean }>`
  align-items: center;
  color: ${({ active }) => (active ? '#3564fd' : '#565656')};
  font-size: 14px;
  border: none;
  padding-top: 12px;
  padding-bottom: 12px;
  && {
    border-bottom: none;
  }
  & svg {
    font-size: 24px;
    margin: auto 0;
  }
  @media (max-width: 480px) {
    padding-left: 20px;
  }
`;

export const StyledLogoTipo = styled.img`
  margin: 27px 24px;
  @media (max-width: 740px) {
    display: none;
  }
`;

export const MenuDivider = styled(Divider)`
  @media (min-width: 740px) {
    display: none;
  }
`;

export const MenuProfileInfo = styled(ProfileInfo)`
  @media (min-width: 740px) {
    display: none;
  }
`;

export const MenuFooter = styled.div`
  margin-top: auto;
  padding: 0 37px 43px;
  text-align: center;
`;

export const TextInnerFooter = styled.span`
  display: inline-block;
  font-size: 18px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.33;
  letter-spacing: normal;
  text-align: center;
  color: #3a3a3a;
  user-select: none;
  margin-bottom: 10px;
`;

export const StoresLinks = styled.a`
  display: inline-block;
  margin-top: 15px;
  height: 41px;
  text-decoration: none;
`;
